import type { FC, SVGProps } from "react";

/** Glossy accent info mark heading a confirmation dialog. */
const InfoGlossyIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#info-glossy-clip)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.0008 3.34213C7.21873 3.34213 3.34213 7.21873 3.34213 12.0008C3.34213 16.7828 7.21873 20.6594 12.0008 20.6594C16.7828 20.6594 20.6594 16.7828 20.6594 12.0008C20.6594 7.21873 16.7828 3.34213 12.0008 3.34213ZM0.859375 12.0008C0.859375 5.84754 5.84754 0.859375 12.0008 0.859375C18.154 0.859375 23.1421 5.84754 23.1421 12.0008C23.1421 18.154 18.154 23.1421 12.0008 23.1421C5.84754 23.1421 0.859375 18.154 0.859375 12.0008ZM12.0008 11.3448C12.6863 11.3448 13.2421 11.9006 13.2421 12.5862V17.7586C13.2421 18.4442 12.6863 19 12.0008 19C11.3152 19 10.7594 18.4442 10.7594 17.7586V12.5862C10.7594 11.9006 11.3152 11.3448 12.0008 11.3448Z"
				fill="url(#info-glossy-ring)"
			/>
			<g filter="url(#info-glossy-blur)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M11.8867 5.0142C12.5723 5.0142 13.1281 5.56998 13.1281 6.25558L13.1281 8.51674C13.1281 9.20233 12.5723 9.75812 11.8867 9.75812C11.2011 9.75812 10.6453 9.20233 10.6453 8.51674L10.6453 6.25558C10.6453 5.56998 11.2011 5.0142 11.8867 5.0142Z"
					fill="url(#info-glossy-dot)"
					fillOpacity="0.9"
				/>
			</g>
		</g>
		<defs>
			<filter
				id="info-glossy-blur"
				x="-4.35547"
				y="-9.98438"
				width="32.4844"
				height="34.7422"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feGaussianBlur in="BackgroundImageFix" stdDeviation="7.5" />
				<feComposite
					in2="SourceAlpha"
					operator="in"
					result="effect1_backgroundBlur"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_backgroundBlur"
					result="shape"
				/>
			</filter>
			<linearGradient
				id="info-glossy-ring"
				x1="16.9666"
				y1="9.51791"
				x2="-8.27478"
				y2="31.8627"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#7370FF" />
				<stop offset="1" stopColor="#7370FF" stopOpacity="0" />
			</linearGradient>
			<radialGradient
				id="info-glossy-dot"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(11.8867 8.41478) rotate(-45) scale(4.32589)"
			>
				<stop stopColor="#7370FF" />
				<stop offset="1" stopColor="#7370FF" stopOpacity="0" />
			</radialGradient>
			<clipPath id="info-glossy-clip">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

export { InfoGlossyIcon };
